(ns common.ai.deal-one-pager-defaults)

(def opportunity-brief-instructions
  (str
   "Create a one-page opportunity brief for a senior decision-maker preparing "
   "for a business discussion. Lead with the material takeaway and use these "
   "content priorities:\n"
   "1. Identify the company, asset, or product and any evidenced associated companies.\n"
   "2. Summarize the opportunity, history, engagement period, and current status. "
   "Use engagement-status=unknown when the record does not support a status. "
   "Pipeline stage, a generic record status, and record creation or update dates "
   "do not by themselves prove an active engagement.\n"
   "3. Summarize recorded email discussions. If there are no email activities, "
   "use email-discussion-state=no-emails and do not invent a summary.\n"
   "4. Summarize available documents, including innovation, development status, "
   "or other material facts only when supported by extracted text. Respect each "
   "attachment status and caveat. If attachments is empty, use "
   "document-state=no-documents. An extraction failure is not the same as no documents.\n"
   "5. Select the last evidenced internal and partner contacts only from the "
   "provided contact candidates. Use contact status=unknown when unsupported.\n"
   "6. Include only materially useful, evidenced content. Do not fill space by "
   "describing absent or inapplicable information. Keep data-quality-notes empty "
   "unless a record limitation materially changes how the brief should be read; "
   "when needed, use at most one concise note. Never expose byte counts, internal "
   "reason codes, extraction implementation details, or other system diagnostics.\n"
   "7. Cite only evidence ids present in the record JSON.\n"
   "8. Keep every populated section concise enough for a single rendered page. "
   "Use complete sentences and do not end content with an ellipsis."))
